import { render, staticRenderFns } from "./safeView.vue?vue&type=template&id=2dfe93ca&scoped=true"
import script from "./safeView.vue?vue&type=script&lang=js"
export * from "./safeView.vue?vue&type=script&lang=js"
import style0 from "./safeView.vue?vue&type=style&index=0&id=2dfe93ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe93ca",
  null
  
)

export default component.exports